export default __webpack_public_path__ + "assets/logoTilePreviewExample.73d7e0.png";